import * as React from 'react';
import ModalComponent from '../Modal/Modal';
import type { BaseModalSize } from '../BaseModal/BaseModal';
import type { ModalContext } from '../Modal/types';
import Button from '../Button/Button';
import cn from '~modules/cn';
import CloseIcon from '../../../assets/icons/v2design/basics/close.svg';

import './info-modal.scss';

export type InfoModalProps = {
    Modal?: React.ElementType;
    size?: BaseModalSize;
    addDim?: boolean;
    containerClassName?: string;
    modalRef?: React.MutableRefObject<ModalContext | null>;
    dataTestId?: string;
    onClose?: () => void;
    icon?: React.ReactNode;
    title?: React.ReactNode;
    description: React.ReactNode;
    isDescriptionWithBreaks?: boolean;
    onBeforeClose?: () => boolean | void;
    showConfirmButton?: boolean;
    footer?: React.ReactNode;
    showCloseButton?: boolean;
};

const InfoModal = (props: InfoModalProps) => {
    const ResultModal = props.Modal || ModalComponent;
    const footer = 'footer' in props && props.footer;
    const showConfirmButton = 'showConfirmButton' in props ? props.showConfirmButton ?? true : !footer;
    return (
        <ResultModal
            onClose={props.onClose}
            addDim={props.addDim}
            size={props.size || 'x-small'}
            showCloseButton={false}
            containerClassName={props.containerClassName}
            fullScreen
            useBaseModal
            setRef={props.modalRef}
            dataTestId={props.dataTestId}
            className="info-modal-wrapper"
            onBeforeClose={props.onBeforeClose}
            label={props.title}
        >
            <div className="info-modal info-modal__centered">
                {props.showCloseButton && (
                    <Button
                        type="button"
                        buttonType="tertiary"
                        buttonSize="small"
                        className="info-modal__close-button"
                        icon={<CloseIcon />}
                        onClick={props.onClose}
                    />
                )}
                <div className="info-modal__wrapper">
                    <div className="info-modal__body-top">
                        {props.icon && <div className="info-modal__icon">{props.icon}</div>}
                        {props.title && <h3 className="info-modal__title">{props.title}</h3>}
                        <div
                            className={cn('info-modal__description', {
                                'info-modal__description--line-break': props.isDescriptionWithBreaks
                            })}
                        >
                            {props.description}
                        </div>
                    </div>
                    {(showConfirmButton || footer) && (
                        <div className="info-modal__buttons-row">
                            {showConfirmButton && (
                                <Button
                                    buttonSize="small"
                                    type="button"
                                    buttonType="tertiary"
                                    onClick={() => props.modalRef?.current?.close()}
                                    data-testid="info-modal-ok-button"
                                >
                                    OK
                                </Button>
                            )}
                            {footer}
                        </div>
                    )}
                </div>
            </div>
        </ResultModal>
    );
};

export default InfoModal;
